resourcePaths = '{"rootPath":"","assetsPath":""}';function _ContentLayout() {
    this.init = function() {};

    this.initAllReady = function() {};

    // Find all children and relayout
    this.reLayoutChildren = function() {
        var children = $("[data-mogo-ui]", this.node);
        for (var i = 0; i < children.length; i++) {
            var comp = $(children[i]).mogo();
            if (comp.create == undefined && comp.reLayout)
                comp.reLayout();
        }
    };

    // Method should be overridden by implementing class, if needed
    this.reLayout = function() {};
}